(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Reports.Results",
                {
                    url: "/Results",
                    component: "reportResults",
                    resolve: {
                        report: [function () {
                            return JSON.parse(sessionStorage.getItem("__report"));
                        }],
                        reportFields: ["reportFields", "report", function (reportFields, report) {
                            return reportFields[report.Type];
                        }],
                        unsaved: [function () {
                            return sessionStorage.getItem("__unsavedReport");
                        }],
                        riskTolerances: ["riskTolerances", function (riskTolerances) {
                            return riskTolerances;
                        }],
                        investmentKnowledges: ["investmentKnowledges", function (investmentKnowledges) {
                            return investmentKnowledges;
                        }],
                        customFields: ["customFieldApi", function (customFieldApi) {
                            return customFieldApi.getAllCustomFields();
                        }]
                    },
                    onExit: ["$transition$", function (trans) {
                        if (trans.to().name !== "Home.Reports.Edit.FieldGridView" && trans.to().name !== "Home.Reports.New.FieldGridView") {
                            sessionStorage.removeItem("__report");
                            sessionStorage.removeItem("__unsavedReport");
                        }
                    }]
                });
        }
    ]);

    app.component("reportResults",
        {
            templateUrl: "/App/Reports/Results/results-template.html",
            controller: resultsController,
            bindings: {
                report: "=",
                results: "<",
                reportFields: "<",
                unsaved: "<",
                currentUser: "<",
                riskTolerances: "<",
                investmentKnowledges: "<",
                customFields: "<"
            }
        });

    resultsController.$inject = ["_", "$q", "$scope", "$state", "$transitions", "$timeout", "$mdDialog", "moment", "reportApi"];
    function resultsController(_, $q, $scope, $state, $transitions, $timeout, $mdDialog, moment, reportApi) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {},
                runReport: runReport,
                saveReport: saveReport,
                exportReport: exportReport,
                editReport: editReport,
                sortResults: sortResults
            });

        var errorAlert = $mdDialog.alert({
            focusOnOpen: false,
            title: "An error running the report has occured.",
            ariaLabel: "Error alert",
            ok: "Close",
            skipHide: true
        });

        var deregisterFn = $transitions.onStart({ to: "**", exiting: "Home.Reports.Results" },
            function (trans) {
                //console.log(trans.to().name);
                if (trans.to().name !== "Home.Reports.Edit.FieldGridView" && trans.to().name !== "Home.Reports.New.FieldGridView" && $ctrl.unsaved) {
                    var confirm = $mdDialog.confirm({
                        theme: "confirmDelete",
                        title: "Unsaved Changes",
                        textContent: "Are you sure you want to leave? All unsaved changes to the report will be lost.",
                        ariaLabel: "Unsaved report changes",
                        ok: "Leave",
                        cancel: "Cancel",
                        onComplete: function () {
                            var $dialog = ng.element(document.querySelector("md-dialog"));
                            var $actionsSection = $dialog.find("md-dialog-actions");
                            var $cancelButton = $actionsSection.children()[0];
                            $cancelButton.focus();
                        }
                    });

                    return $mdDialog.show(confirm).then(function () {
                    },
                        function () {
                            trans.abort();
                        });
                }
            });
        this.$onDestroy = deregisterFn;

        function getReportResults(nextPageToken) {
            return reportApi.runReport($ctrl.report, nextPageToken).then(function (results) {
                if (!results.Rows.NextPage) return results;
                return getReportResults(results.Rows.NextPage).then(function (response) {
                    results.Rows.Entries = _.concat(results.Rows.Entries, response.Rows.Entries);
                    return results;
                });
            });
        }

        function runReport() {
            $ctrl.ui.loading = true;
            $ctrl.results = null;
            let customfields = [];
            let defaultFields = [];

            getReportResults().then(function (response) {
                $ctrl.results = response;
                updateDateValues();
                $ctrl.reverseSort = !$ctrl.reverseSort;
                $ctrl.sortResults($ctrl.sortIndex || 0);

                //due to the result fields including both saved properties & custom properties, splitting the 2 to retrieve default field's DisplayName in correct order
                //before joining them back to custom fields

                $ctrl.results.Fields.forEach(field => {
                    $ctrl.reportFields.forEach(reportField => {
                        if (field.Name === reportField.Name) {
                            defaultFields.push({ Name: reportField.DisplayName, CustomFieldId: null, Type: reportField.Type });
                        }
                    });
                });

                if ($ctrl.report.CustomProperties) {
                    let customPropsLength = $ctrl.report.CustomProperties.Parameters.length;
                    customfields = $ctrl.results.Fields.slice($ctrl.results.Fields.length - customPropsLength, $ctrl.results.Fields.length);

                    customfields = customfields.map(function (field) {
                        var found = $ctrl.customFields.find(function (f) {
                            f.Id === field.CustomFieldId;
                        });
                        if (found) {
                            field.Type = found.CustomFieldType;
                        }
                        return field;
                    });

                    $ctrl.results.JointFields = defaultFields.concat(customfields);
                } else {
                    $ctrl.results.JointFields = defaultFields;
                }

                $ctrl.ui.loading = false;
            }).catch(function (error) {
                $ctrl.ui.loading = false;
                $mdDialog.show(errorAlert);
            });
        }

        function updateDateValues() {
            var indexes = [];

            ng.forEach($ctrl.results.Fields,
                function (field, index) {
                    if (field.Name === "StartDate" ||
                        field.Name === "EndDate" ||
                        field.Name === "DueDate" ||
                        field.Name === "LatestAccountStatusDate" ||
                        field.Name === "DateOfBirth" ||
                        field.Name === "AccountValueUpdatedOn" ||
                        field.Name === "SurrenderDate" ||
                        field.Name === "DateReferredOn") {
                        indexes.push(index);
                    }
                });

            ng.forEach($ctrl.results.Rows.Entries,
                function (entry) {
                    ng.forEach(indexes,
                        function (index) {
                            if (entry[index]) {
                                var field = $ctrl.results.Fields[index];

                                var format = field.Name === "DueDate" || field.Name === "LatestAccountStatusDate" || field.Name === "DateOfBirth" || field.Name === "AccountValueUpdatedOn" || field.Name === "SurrenderDate" || field.Name === "DateReferredOn"
                                    ? "ll"
                                    : "lll";

                                entry[index] = moment.utc(entry[index], "MM/DD/YYYY hh:mm a").format(format);
                            }
                        });
                });
        }

        function saveReport() {
            $ctrl.ui.saving = true;

            var promises = [];

            if (!$ctrl.report.Id) {
                promises.push(reportApi["create" + $ctrl.report.Type + "Report"]($ctrl.report));
            } else {
                promises.push(reportApi["update" + $ctrl.report.Type + "Report"]($ctrl.report.Id, $ctrl.report));
            }

            $q.all(promises)
                .then((response) => {
                    if (!$ctrl.report.Id) {
                        $ctrl.report.Id = response[0].Id;
                        $ctrl.report.Type = response[0].Type;
                        //$state.go("Home.Reports.Edit", { type: response[0].Type, reportId: response[0].Id });
                    }

                    sessionStorage.removeItem("__unsavedReport");
                    $ctrl.unsaved = false;
                    $ctrl.ui.saved = true;
                    $ctrl.ui.saving = false;
                    $timeout(function () {
                        $ctrl.ui.saved = false;
                    },
                        5000);
                })
                .catch((error) => {
                    console.log("Error", error);
                });
        }

        function getReportFile(exportedReportId) {
            return reportApi.getExportedReport(exportedReportId).then(function (response) {
                if (response === null)
                    return getReportFile(exportedReportId);
                else return response;
            });
        }

        function exportReport() {
            $ctrl.ui.exporting = true;

            reportApi.export($ctrl.report).then(function (response) {
                getReportFile(response.Id).then(function (file) {
                    var f = document.createElement("a");
                    document.body.appendChild(f);
                    f.style = "display:none";

                    var fUrl = window.URL.createObjectURL(file);
                    f.href = fUrl;
                    f.download = $ctrl.report.Name ? $ctrl.report.Name + ".xls" : `untitled-${$ctrl.report.Type}-report.xls`;
                    f.click();
                    $ctrl.ui.exporting = false;

                    $timeout(function () {
                        document.body.removeChild(f);
                        window.URL.revokeObjectURL(fUrl);
                    },
                        100);
                });
            });
        }

        function editReport() {
            if (!$ctrl.report.Id)
                $state.go("Home.Reports.New", { type: $ctrl.report.Type });
            else
                $state.go("Home.Reports.Edit", { type: $ctrl.report.Type, reportId: $ctrl.report.Id });
        }

        function sortResults(index) {
            if ($ctrl.sortIndex !== index) {
                $ctrl.sortIndex = index;
                $ctrl.reverseSort = false;
            } else {
                $ctrl.reverseSort = !$ctrl.reverseSort;
            }


            $ctrl.results.Rows.Entries.sort(function (rowA, rowB) {

                // Get items from the columns to be ordered
                var a = rowA[$ctrl.sortIndex];
                var b = rowB[$ctrl.sortIndex];
                var order = $ctrl.reverseSort ? -1 : 1;

                // Enforces nulls are at the bottom of theresults regardless of sort direction
                if (!a) return 1;
                if (!b) return -1;

                if ($ctrl.results.JointFields && $ctrl.results.JointFields[$ctrl.sortIndex]) {
                    if ($ctrl.results.JointFields[$ctrl.sortIndex].Type === "DateTime") {
                        var dateA = new Date(a);
                        var dateB = new Date(b);
                        return (dateA > dateB ? 1 : dateA === dateB ? 0 : -1) * order;
                    }
                    else if ($ctrl.results.JointFields[$ctrl.sortIndex].Type === "decimal") {
                        var numA = Number(a);
                        var numB = Number(b);
                        return (numA > numB ? 1 : numA === numB ? 0 : -1) * order;
                    }
                }

                return (a.toUpperCase() > b.toUpperCase() ? 1 : a === b ? 0 : -1) * order;
            });

            //  update report model
            $ctrl.report.OrderColumn = $ctrl.results.Fields[$ctrl.sortIndex];
            $ctrl.report.OrderDirection = $ctrl.reverseSort ? "Desc" : "Asc";

        }

        $ctrl.isDate = function (date) {
            return date !== null && (new Date(date).toString() !== "Invalid Date") && !isNaN(new Date(date));
        };

        $ctrl.$onInit = () => {
            $ctrl.runReport();
        };
    }

})(window.app, window.angular);

//TODO: Custom field headers